import {
    GALLERY_ADS_FETCH,
} from '../actions/constants'

const defaultState = {
    total: undefined,
    items: []
};

export default (state = defaultState, action) => {
    switch (action.type){
        case GALLERY_ADS_FETCH:
            return {
                ...state,
                total: action.payload.count,
                items: [...state.items, ...action.payload.results],
            }
        default:
            return state;
    }
};